import styled from "styled-components";

export const CloseIconWrapper = styled.span`
  position: relative;
  left: 20px;
`;
